import type { ReactNode } from "react";

export function ReportPreview({ children }: { children: ReactNode }) {
  return (
    <div className="report-preview-pane" aria-label="Prévia do PDF">
      <div className="report-preview-scale">{children}</div>
    </div>
  );
}
